import { SVGProps } from "react";

const ShareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.875 5.74219H8.53125C8.88672 5.74219 9.1875 6.04297 9.1875 6.39844V7.05469V7.84766L12.4688 4.86719L9.1875 1.91406V2.67969V3.33594C9.1875 3.71875 8.88672 3.99219 8.53125 3.99219H7.875H4.8125C2.87109 3.99219 1.3125 5.57812 1.3125 7.49219C1.3125 7.92969 1.33984 8.3125 1.44922 8.64062C1.91406 6.97266 3.41797 5.74219 5.25 5.74219H7.875ZM7.875 7.05469V7.08203H6.5625H5.25C3.80078 7.08203 2.625 8.25781 2.625 9.70703C2.625 10.1719 2.73438 10.5273 2.87109 10.8008C2.92578 10.8828 2.95312 10.9375 3.00781 11.0195C3.08984 11.1016 3.14453 11.1836 3.22656 11.2383C3.22656 11.2656 3.25391 11.2656 3.25391 11.293C3.39062 11.4297 3.47266 11.5938 3.47266 11.7852C3.47266 12.0859 3.25391 12.3047 2.95312 12.3047C2.87109 12.3047 2.78906 12.3047 2.73438 12.2773C2.65234 12.2227 2.54297 12.168 2.43359 12.0859C2.35156 12.0312 2.26953 11.9766 2.1875 11.9219C2.07812 11.8398 1.96875 11.7578 1.85938 11.6758C1.03906 10.9648 0 9.625 0 7.49219C0 4.83984 2.13281 2.67969 4.8125 2.67969H6.5625H7.875V1.36719V0.929688C7.875 0.601562 8.06641 0.273438 8.39453 0.136719C8.69531 0 9.07812 0.0546875 9.32422 0.300781L13.6992 4.23828C13.8906 4.40234 14 4.62109 14 4.86719C14 5.14062 13.8906 5.35938 13.6992 5.52344L9.32422 9.46094C9.07812 9.70703 8.69531 9.76172 8.39453 9.625C8.06641 9.48828 7.875 9.16016 7.875 8.80469V8.36719V7.05469Z"
      fill="currentColor"
    />
  </svg>
);

export default ShareIcon;
